import cx from "classnames";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export enum ButtonType {
  primary = "primary",
  secondary = "secondary",
  danger = "danger",
}

interface IButtonProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: (event: any) => void;
  type?: ButtonType;
  htmlType?: "button" | "submit" | "reset";
  disabled?: boolean;
  style?: React.CSSProperties;
  isLoading?: boolean;
}

const Button = (props: IButtonProps) => {
  const {
    children,
    onClick,
    type,
    htmlType = "button",
    disabled,
    style,
    isLoading,
    className,
    ...rest
  } = props;
  return (
    <button
      type={htmlType}
      className={cx(
        "button",
        {
          button__primary: type === ButtonType.primary,
          button__secondary: type === ButtonType.secondary,
          button__danger: type === ButtonType.danger,
          disabled: disabled,
        },
        className,
      )}
      disabled={disabled || isLoading}
      onClick={onClick}
      style={{
        ...style,
        display: isLoading ? "flex" : style?.display,
        alignItems: isLoading ? "center" : style?.alignItems,
        justifyContent: isLoading ? "center" : style?.justifyContent,
      }}
      {...rest}
    >
      {isLoading ? <LoadingSpinner inline /> : children}
    </button>
  );
};

export default Button;
